import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Row, Col, Button } from "reactstrap";

import { getMessage } from "CONFIG/i18n";
import {getTimeInLocaleTimezone, formatDateByLocale, getElapseTimeInHhMm} from "UTILS/DateUtils";

import RetireInstanceConfirmationModal from"./RetireInstanceConfirmationModal";

import { KMSInstanceInfo } from "UTILS/Constants";

import { getBootstrapTableOptions } from "UTILS/Utility";

import "./Organisations.less";

export default class ClusterInformationList extends Component{
  constructor(props) {
    super(props);
    this.state = {
      isAnyInstanceSelected: false,
      showRetireInstanceConfirmationModal: false,
      selectedInstances: []
    };
    // this.clusterData = [
    //   {"instanceId":"i-0eebbbb53f7aad42b","ipAddress":"10.0.2.234","status":"stopped","isRetired":false,"createdAt":"2020-06-08T13:19:59.000Z","updatedAt":"2020-06-08T13:20:36.000Z","kmsInfo":{"cpuUsage":1,"ramUsage":4.3,"activePipelineCount":3,"diskUsage":null,"isHealthy":"HEALTHY","recoveryAttempts":0,"isIdle":true,"lastStartedAt":"2020-06-08T13:20:29.000Z","updatedAt":"2020-06-08T13:49:00.000Z","createdAt":"2020-06-08T13:20:36.000Z"}},
    //   {"instanceId":"i-04fd1092599f245f3","ipAddress":"10.0.2.208","status":"running","isRetired":false,"createdAt":"2020-06-08T13:19:59.000Z","updatedAt":"2020-06-08T13:20:36.000Z"},
    //   {"instanceId":"i-09eb8c8b6bb006085","ipAddress":"10.0.3.62","status":"running","isRetired":false,"createdAt":"2020-06-08T13:41:48.000Z","updatedAt":"2020-06-08T13:42:34.000Z","kmsInfo":{"cpuUsage":1,"ramUsage":4.5,"activePipelineCount":1,"diskUsage":null,"isHealthy":"HEALTHY","recoveryAttempts":0,"isIdle":false,"lastStartedAt":"2020-06-08T13:42:24.000Z","updatedAt":"2020-06-08T13:49:00.000Z","createdAt":"2020-06-08T13:42:34.000Z"}},
    //   {"instanceId":"i-0ad5f2387b8a4c612","ipAddress":"10.0.2.81","status":"running","isRetired":false,"createdAt":"2020-06-08T13:45:01.000Z","updatedAt":"2020-06-08T13:45:36.000Z","kmsInfo":{"cpuUsage":0,"ramUsage":4.6,"activePipelineCount":2,"diskUsage":null,"isHealthy":"HEALTHY","recoveryAttempts":0,"isIdle":true,"lastStartedAt":"2020-06-08T13:45:30.000Z","updatedAt":"2020-06-08T13:49:00.000Z","createdAt":"2020-06-08T13:45:36.000Z"}}];
  }

  openModal=()=>{
    this.setState({showRetireInstanceConfirmationModal:true})
  }

  handleRetireInstanceCancelClick=()=>{
    this.setState(
      {showRetireInstanceConfirmationModal: !this.state.showRetireInstanceConfirmationModal})
  }

  handleRetireInstanceOkClick = () => {
    this.props.retireInstance((this.state.selectedInstances),(message)=>{
      this.handleRetireInstanceCancelClick();
      this.props.getClusterInfo();
      document.getElementsByClassName('checkRetireInstance').forEach(chkbox => chkbox.checked = false);
      this.setState({isAnyInstanceSelected:!this.state.isAnyInstanceSelected})
    });
  }

  setRetireInstance = (event, instanceId) => {
    let selectedInstances = this.state.selectedInstances;
    if(event.currentTarget.checked) {
      selectedInstances.push(instanceId);
    } else {
      const index = selectedInstances.indexOf(instanceId);
      if (index > -1) {
        selectedInstances.splice(index, 1);
      }
    }
    this.setState({
      selectedInstances: selectedInstances,
      isAnyInstanceSelected: selectedInstances.length > 0
    });
  }

  serialNumberFormat = (cell, row, enumObject, index) =>{
    return(
      <div> {index+1} </div>
    )
  }

  selectionFormat = (cell, row) => {
    return (
      <div>
        <input type="checkbox"
          className="checkRetireInstance"
          onClick={e => this.setRetireInstance(e, row.instanceId)}
          disabled={row.isRetired}
        />
      </div>
    )
  }
  
  ipAddressFormat = (cell,row) =>{
    return (
      <div>
        {row.ipAddress}
      </div>
    )
  }

  cpuUsageFormat = (cell,row) =>{
    return(
      <div>
        { (row.kmsInfo && row.status === KMSInstanceInfo.instanceStatus.RUNNING)
          ? row.kmsInfo.cpuUsage
          : "--"
        }
      </div>
    )
  }

  healthFormat = (cell,row) =>{
    return(
      <div>
        <label className="clusterDataFont">
          { row.isRetired
            ? getMessage(row.kmsInfo.isHealthy)
            : (row.kmsInfo && row.kmsInfo.isHealthy && row.status != KMSInstanceInfo.instanceStatus.STOPPED)
              ? getMessage(row.kmsInfo.isHealthy)
              : "--"
          }
        </label>
      </div>
    )
  }

  statusFormat = (cell,row) =>{
    return(
      <div>
        {row.status ? getMessage(row.status) : "--"}
      </div>
    )
  }

  memoryUsageFormat = (cell,row) =>{
    return(
      <div>
        { (row.kmsInfo && row.status === KMSInstanceInfo.instanceStatus.RUNNING)
          ? row.kmsInfo.ramUsage
          : "--"
        }
      </div>
    )
  }

  sortByUsage = (a, b, order, field) => {
    if(a.kmsInfo && b.kmsInfo) {
      if (order === 'desc') {
        return (a.kmsInfo[field] < b.kmsInfo[field]) ? 1 : -1;
      }
      return (a.kmsInfo[field] > b.kmsInfo[field]) ? 1 : -1;
    }
    return 0;
  }

  pipelineFormat = (cell, row) =>{
    return(
      <div>
        { (row.kmsInfo && row.status === KMSInstanceInfo.instanceStatus.RUNNING)
          ? row.kmsInfo.activePipelineCount
          : "--"
        }
      </div>
    )
  }

  createdTimeFormat = (cell, row) =>{
    return(
      <>
        <div className="nameEllipsis">
          {row.kmsInfo ? formatDateByLocale(row.kmsInfo.createdAt, this.props.language) : "--"}
        </div>
        <div>
          {row.kmsInfo ? getTimeInLocaleTimezone(row.kmsInfo.createdAt) : "--"}
        </div>
      </>
    )
  }

  totalRunningHrsFormat = (cell, row) =>{
    return(
      
      <div>
        { (row.kmsInfo && row.status === KMSInstanceInfo.instanceStatus.RUNNING)
          ? getElapseTimeInHhMm(row.kmsInfo.lastStartedAt)
          : "--"
        }
      </div>
    )
  }  

  lastServedAtFormat = (cell, row) =>{
    return (
      <>
        <div className="nameEllipsis">
          {row.kmsInfo ? formatDateByLocale(row.kmsInfo.lastServedAt, this.props.language) : "--"}
        </div>
        <div>
          {row.kmsInfo ? getTimeInLocaleTimezone(row.kmsInfo.lastServedAt) : "--"}
        </div>
      </>
    )
  }

  remainingCapacityFormat = (cell, row) =>{
    return (
      <div>
        { (row.kmsInfo && row.status === KMSInstanceInfo.instanceStatus.RUNNING)
          ? row.kmsInfo.capacity
          : "--"
        }
      </div>
    )
  }

  ///**********************************************************************************/////////
  instanceId = (cell,row) =>{
    return (
      <div>
        {row.instanceId ? row.instanceId : "--"}
      </div>
    )
  }

  cpuUsage = (cell,row) =>{
    return(
      <div>
        {row.cpuUsage ? row.cpuUsage : "--"}
      </div>
    )
  }

  ramUsage = (cell,row) =>{
    return(
      <div>
        {row.ramUsage ? row.ramUsage : "--"}
      </div>
    )
  }

  activeSessionsCount = (cell, row) =>{
    return(
      <div>
        {row.activeSessionsCount >= 0 ? row.activeSessionsCount : "--"}
      </div>
    )
  }

  isProtected = (cell,row) =>{
    return(
      <div>
        <label className="clusterDataFont">
          { row.isProtected ? getMessage("ON") : row.isProtected === false ? getMessage("OFF") : "--" }
        </label>
      </div>
    )
  }
  
  statusCount = (cell,row) =>{
    return(
      <div>
        {row.statusCount >= 0 ? row.statusCount : "--"}
      </div>
    )
  }

  updatedAt = (cell, row) =>{
    return(
      <div className="nameEllipsis">
        {row.updatedAt ? formatDateByLocale(row.updatedAt, this.props.language) 
          + " " + getTimeInLocaleTimezone(row.updatedAt) : "--"}
      </div>
    )
  }

  renderKmsStats = () => {
    return(
      <BootstrapTable
        data={this.props.clusterData}
        tableHeaderClass="tableHeader"
        tableBodyClass='tableBody'
        containerClass='organisationsList'
        tableContainerClass=''
        headerContainerClass=''
        bodyContainerClass=''
        bordered={false}
        options={getBootstrapTableOptions()}
      >

        <TableHeaderColumn
          dataField='select'
          width="8%"
          dataFormat={this.selectionFormat}
          dataAlign='center'
        >
          <div> 
            {getMessage("SELECTION")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='any'
          dataFormat={this.serialNumberFormat}
          width="5%"
          dataAlign='center'
          isKey
        >
          <div>
            {getMessage("SR_NO")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='ip'
          width="15%"
          dataAlign='center'
          dataFormat={this.ipAddressFormat}
        >
          <div>
            {getMessage("IP")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='cpuUsage'
          width="13%"
          dataAlign='center'
          dataSort={true}
          sortFunc={this.sortByUsage}
          dataFormat={this.cpuUsageFormat}
        >
          <div>
            {getMessage("CPU")} 
          </div>
          <div>
              (%) 
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='ramUsage'
          width="13%"
          dataAlign='center'
          dataSort={true}
          sortFunc={this.sortByUsage}
          dataFormat={this.memoryUsageFormat}
        >
          <div>
            {getMessage("MEMORY")}
          </div>
          <div>
              (%) 
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='activePipelineCount'
          width="15%"
          dataAlign='center'
          dataSort={true}
          sortFunc={this.sortByUsage}
          dataFormat={this.pipelineFormat}
        >
          <div>
            {getMessage("MEETINGS")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='remainingCapacity'
          width="13%"
          dataAlign='center'
          dataSort={true}
          sortFunc={this.sortByUsage}
          dataFormat={this.remainingCapacityFormat}
        >
          <div>
            {getMessage("REMAINING_CAPACITY")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='healthcheck'
          width="13%"
          dataAlign='center'
          dataFormat={this.healthFormat}
        >
          <div>
            {getMessage("HEALTH_CHECK")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='status'
          width="13%"
          dataAlign='center'
          dataFormat={this.statusFormat}
        >
          <div>
            {getMessage("STATUS")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='totalRunningHrs'
          width="15%"
          dataAlign='center'
          dataFormat={this.totalRunningHrsFormat}
        >
          <div>
            {getMessage("TOTAL_RUNNING_HOURS")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='creationTime'
          width="15%"
          dataAlign='center'
          dataFormat={this.createdTimeFormat}
        >
          <div>
            {getMessage("CREATION_TIME")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='lastServedAt'
          width="15%"
          dataAlign='center'
          dataFormat={this.lastServedAtFormat}
        >
          <div>
            {getMessage("LAST_SERVED_AT")}
          </div>
        </TableHeaderColumn>

      </BootstrapTable>
    )
  }

  renderTurnStats = () => {
    console.log("------------------------", this.props.usingTurnCluster, this.props.turnClusterData);
    return(
      <BootstrapTable
        data={this.props.turnClusterData}
        tableHeaderClass="tableHeader"
        tableBodyClass='tableBody'
        containerClass='organisationsList'
        tableContainerClass=''
        headerContainerClass=''
        bodyContainerClass=''
        bordered={false}
        options={getBootstrapTableOptions()}
      >

        <TableHeaderColumn
          dataField='any'
          dataFormat={this.serialNumberFormat}
          width="8%"
          dataAlign='center'
          isKey
        >
          <div>
            {getMessage("SR_NO")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='ip'
          width="15%"
          dataAlign='center'
          dataFormat={this.instanceId}
        >
          <div>
            {getMessage("INSTANCE_ID")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='cpuUsage'
          width="15%"
          dataAlign='center'
          dataSort={true}
          sortFunc={this.sortByUsage}
          dataFormat={this.cpuUsage}
        >
          <div>
            {getMessage("CPU")} 
          </div>
          <div>
              (%) 
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='ramUsage'
          width="15%"
          dataAlign='center'
          dataSort={true}
          sortFunc={this.sortByUsage}
          dataFormat={this.ramUsage}
        >
          <div>
            {getMessage("MEMORY")}
          </div>
          <div>
              (%) 
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='activeSessionsCount'
          width="15%"
          dataAlign='center'
          dataSort={true}
          sortFunc={this.sortByUsage}
          dataFormat={this.activeSessionsCount}
        >
          <div>
            {getMessage("TURN_SESSIONS")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='isProtected'
          width="15%"
          dataAlign='center'
          dataFormat={this.isProtected}
        >
          <div>
            {getMessage("SCALE_IN_PROTECTION")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='status'
          width="15%"
          dataAlign='center'
          dataFormat={this.statusCount}
        >
          <div>
            {getMessage("STATUS_COUNT")}
          </div>
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField='creationTime'
          width="23%"
          dataAlign='center'
          dataFormat={this.updatedAt}
        >
          <div>
            {getMessage("UPDATED_TIME")}
          </div>
        </TableHeaderColumn>

      </BootstrapTable>
    )
  }
  
  render(){
    return(
      <div className="clusterInfoListContainer">
        <RetireInstanceConfirmationModal
          showRetireInstanceConfirmationModal={this.state.showRetireInstanceConfirmationModal}
          handleRetireInstanceCancelClick={this.handleRetireInstanceCancelClick}
          handleRetireInstanceOkClick={this.handleRetireInstanceOkClick}
        />
        <Row className="mainTitle flex5">
          {getMessage("KMS_TITLE")}
        </Row>

        <hr />

        {this.renderKmsStats()}
        
        <div className="permissionButtons clusterInfoBtnsDiv">
          <Col className="clusterInfoBtns">
            <Button
              className="buttons customBtn whiteOnClick retireInstanceBtn"
              disabled={!this.state.isAnyInstanceSelected}
              onClick={this.openModal}
            >
              {getMessage("RETIRE_INSTANCE")}
            </Button>
            <Button className="buttons customBtn whiteOnClick refreshBtn" 
              onClick={this.props.getClusterInfo}>
              {getMessage("REFRESH")}
            </Button>
          </Col>
          <Col sm={4} className="refreshLabelDiv">
            <label className="refreshLabel"> {getMessage("LAST_REFRESH_TIME",{refreshTime:this.props.lastRefreshTime})} </label>
          </Col>
        </div>

        <hr />
        
        {this.props.usingTurnCluster &&
          <>
            <Row className="mainTitle flex5">
              {getMessage("TURN")}
            </Row>

            <hr />

            { this.renderTurnStats() }

            <div className="permissionButtons clusterInfoBtnsDiv">
              <Col className="clusterInfoBtns">
                <Button className="buttons customBtn whiteOnClick refreshBtnTurn" 
                  onClick={this.props.getTurnClusterInfo}>
                  {getMessage("REFRESH")}
                </Button>
              </Col>
              <Col sm={4} className="refreshLabelDiv">
                <label className="refreshLabel"> {getMessage("LAST_REFRESH_TIME",{refreshTime:this.props.lastRefreshTimeTurn})} </label>
              </Col>
            </div>
          </>
        }
      </div>
    )
  }
}